// extracted by mini-css-extract-plugin
export default {"link":"style_link__uOeOF","active":"style_active__1yp2K","line":"style_line__ZjZ+T","title":"style_title__wzvVJ","desc":"style_desc__dXPnR"};